
export class IngressData {
  username: string; // Here for model uniformity. necessary for referenceSweep.
  timestamp: number;
  latitude: number;
  longitude: number;
  live: IngressCordinates[];
  max: IngressCordinates[];
  avg: IngressCordinates[];
  agcLevel: number;
  maxIngressValue: number;
  sampleCount: number;

  constructor(
    httpResponse: IngressData
  ) {
    // @ts-ignore
    this.username = httpResponse['userId']; // The backend changes from username to userId a lot. We don't stand for that sort of funny business on the front end.
    this.timestamp = httpResponse.timestamp;
    this.latitude = httpResponse.latitude;
    this.longitude = httpResponse.longitude;
    this.live = httpResponse.live;
    this.max = httpResponse.max;
    this.avg = httpResponse.avg;
    this.agcLevel = httpResponse.agcLevel;
    this.maxIngressValue = httpResponse.maxIngressValue;
    this.sampleCount = httpResponse.sampleCount;
  }
}

/**
 * Inner class to Ingress
 */
class IngressCordinates {
  freq: number;
  power: number;
}
